import { render } from "./MetaDataActions.vue?vue&type=template&id=fc3f7b06"
import script from "./MetaDataActions.vue?vue&type=script&lang=js"
export * from "./MetaDataActions.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__